var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 23,
    viewBox: "0 0 36 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7385 12.0287H9.77634C9.38998 12.0287 9.06958 11.7084 9.06958 11.322C9.06958 10.9356 9.38998 10.6152 9.77634 10.6152H26.7385C27.1248 10.6152 27.4452 10.9356 27.4452 11.322C27.4452 11.7084 27.1248 12.0287 26.7385 12.0287Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.43359 15.5241C3.33498 10.7825 9.57836 1.28497 19.3408 1.22721C29.1032 1.16944 33.9025 1.20314 35.0819 1.22721",
    stroke: "black",
    strokeWidth: 1.61593,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0815 7.47588C33.1802 12.2175 26.9368 21.715 17.1744 21.7728C7.41198 21.8306 2.61263 21.7969 1.43325 21.7728",
    stroke: "black",
    strokeWidth: 1.61593,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleOpen);
export default __webpack_public_path__ + "static/media/toggle-open.ab9fbc35462aedf681d31a9c60d38d29.svg";
export { ForwardRef as ReactComponent };